import { render, staticRenderFns } from "./product_edit.vue?vue&type=template&id=537c2572&"
import script from "./product_edit.vue?vue&type=script&lang=ts&"
export * from "./product_edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports